import { latestSchemaVersion } from '../schema/flameSchema'
import { defineExample, tid, vid } from './util'

/**
 * Jellyfish — bioluminescent deep-sea jellyfish.
 * bubble3D for the bell dome, curl3D + sinusoidal3D for
 * flowing tentacles, and swirl3D for organic movement.
 */
export const example38 = defineExample({
  version: latestSchemaVersion,
  metadata: {
    author: 'unknown',
    name: 'Jellyfish',
    description:
      'bioluminescent deep-sea jellyfish. bubble3D for the bell dome, curl3D + sinusoidal3D for flowing tentacles, and swirl3D for organic movement.',
  },
  renderSettings: {
    dimensions: 3,
    exposure: -2.0,
    skipIters: 20,
    drawMode: 'light',
    colorInitMode: 'colorInitZero',
    pointInitMode: 'pointInitUnitBall',
    vibrancy: 1.3,
    contrast: 3.5,
    gamma: 3.0,
    depthColorPower: 0.0,
    lightDirection: [0, 0.8, -0.3],
    lightPower: 0.1,
    highlightPower: 1.0,
    densityEstimationQuality: 0.7,
    estimatorCurve: 0.4,
    paletteMode: 0,
    palettePhase: 0.45,
    paletteSpeed: 0.5,
    camera: { zoom: 1, position: [0, 0] },
    camera3D: {
      theta: 4.7,
      phi: 1.8,
      radius: 2.3,
      target: [0, 0, 0],
      fov: 55,
    },
  },
  transforms: {
    [tid('3d_jelly_a')]: {
      probability: 0.45,
      preAffine: {
        a: 0.7,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0.7,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.7,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.1, y: 0.4 },
      colorSpeed: 0.4,
      variations: {
        [vid('3d_jelly_a_v0')]: { type: 'bubble3D', weight: 0.8 },
        [vid('3d_jelly_a_v1')]: { type: 'curl3D', weight: 0.3 },
      },
    },
    [tid('3d_jelly_b')]: {
      probability: 0.3,
      preAffine: {
        a: 0.65,
        b: 0.1,
        c: 0,
        d: 0,
        e: -0.1,
        f: 0.65,
        g: 0,
        h: -0.2,
        i: 0,
        j: 0,
        k: 0.8,
        l: -0.1,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: -0.2, y: 0.2 },
      colorSpeed: 0.35,
      variations: {
        [vid('3d_jelly_b_v0')]: { type: 'sinusoidal3D', weight: 0.6 },
        [vid('3d_jelly_b_v1')]: { type: 'curl3D', weight: 0.5 },
      },
    },
    [tid('3d_jelly_c')]: {
      probability: 0.25,
      preAffine: {
        a: 0.5,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0.5,
        g: 0,
        h: 0.1,
        i: 0,
        j: 0,
        k: 0.5,
        l: 0,
      },
      postAffine: {
        a: 0,
        b: -1,
        c: 0,
        d: 0,
        e: 1,
        f: 0,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.5, y: -0.15 },
      colorSpeed: 0.4,
      variations: {
        [vid('3d_jelly_c_v0')]: { type: 'swirl3D', weight: 0.5 },
        [vid('3d_jelly_c_v1')]: { type: 'bubble3D', weight: 0.4 },
      },
    },
  },
})
